<!-- use case 

import EmBreadcrumb from "@/components/EmBreadcrumb";

  <EmBreadcrumb v-bind:breadcrumbItems="breadcrumbItems"></EmBreadcrumb>
-->
<template>
    <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item" v-for="item in breadcrumbItems" :key="item.id">
            <router-link v-if="item.url" v-bind:to="item.url">
                <i v-if="item.icon" v-bind:class="iconClass + item.icon"></i>
                <span>{{$t(item.i18nBreadcrumbName)}}</span>
            </router-link>
            <span v-else>
                <i v-if="item.icon" v-bind:class="iconClass + item.icon"></i>
                {{$t(item.i18nBreadcrumbName)}}
            </span>
        </li>
    </ul>
</template>


<script>

    export default {

        name: "emBreadcrumb",
        props: {
            breadcrumbItems: []
        },
        data() {
            return {
                iconClass: "app-menu__icon fa "
            };
        },
        methods: {
            /**
             * 重新回到父菜单地址
             */
            goBack() {
                let foo = this.breadcrumbItems.length
                if (foo > 2) {
                    this.$router.push(this.breadcrumbItems[foo - 2].url)
                }
            }
        }
    };
</script>
